import {useId} from "react";
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {mb} from "@pg-design/helpers-css";
import {p} from "@pg-design/helpers-css/";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {useElementWasVisible} from "@pg-mono/hooks";

import {gtmOfferGalleryEvents} from "../../../tracking/google_tag_manager/gtm_event_offer_gallery_modal";
import {OfferModalActiveTab} from "../../types/OfferModalActiveTab";

import missingConstructionImagesSVG from "../../detail/img/missing_construction_images.svg";

interface Props {
    onButtonClick: (tab: OfferModalActiveTab) => void;
}

export const OfferConstructionGalleryTile = (props: Props) => {
    const id = useId();
    const onElementVisible = () => gtmOfferGalleryEvents.onConstructionGalleryCTA("view");
    useElementWasVisible({ids: [id], onElementVisible});

    const onButtonClick = () => {
        gtmOfferGalleryEvents.onConstructionGalleryCTA("click");
        props.onButtonClick(OfferModalActiveTab.CONSTRUCTION_GALLERY);
    };

    return (
        <div css={holder} id={id}>
            <Image src={missingConstructionImagesSVG} css={mb(4)} height="146px" width="156px" alt="Kartka papieru z naszkicowanym schematem domu" />
            <Text variant="body_copy_1" color="white" mb={2} align="center">
                Staramy się zagregować jak najwięcej danych o ofertach na naszym portalu, w tym zbierać zdjęcia z <strong>poszczególnych etapów budowy</strong>.
                Czy chcesz je teraz zobaczyć?
            </Text>
            <Button variant="filled_primary" onClick={onButtonClick} css={mb(1)}>
                Pokaż zdjęcia z budowy
            </Button>
        </div>
    );
};

const holder = css`
    ${p(5)};
    ${mb(4)};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    border: 1px solid var(--colors-gray-800);
`;
import {useId} from "react";
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {mb} from "@pg-design/helpers-css";
import {p} from "@pg-design/helpers-css/";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {useElementWasVisible} from "@pg-mono/hooks";

import {gtmOfferGalleryEvents} from "../../../tracking/google_tag_manager/gtm_event_offer_gallery_modal";
import {OfferModalActiveTab} from "../../types/OfferModalActiveTab";

import missingConstructionImagesSVG from "../../detail/img/missing_construction_images.svg";

interface Props {
    onButtonClick: (tab: OfferModalActiveTab) => void;
}

export const OfferConstructionGalleryTile = (props: Props) => {
    const id = useId();
    const onElementVisible = () => gtmOfferGalleryEvents.onConstructionGalleryCTA("view");
    useElementWasVisible({ids: [id], onElementVisible});

    const onButtonClick = () => {
        gtmOfferGalleryEvents.onConstructionGalleryCTA("click");
        props.onButtonClick(OfferModalActiveTab.CONSTRUCTION_GALLERY);
    };

    return (
        <div css={holder} id={id}>
            <Image src={missingConstructionImagesSVG} css={mb(4)} height="146px" width="156px" alt="Kartka papieru z naszkicowanym schematem domu" />
            <Text variant="body_copy_1" color="white" mb={2} align="center">
                Staramy się zagregować jak najwięcej danych o ofertach na naszym portalu, w tym zbierać zdjęcia z <strong>poszczególnych etapów budowy</strong>.
                Czy chcesz je teraz zobaczyć?
            </Text>
            <Button variant="filled_primary" onClick={onButtonClick} css={mb(1)}>
                Pokaż zdjęcia z budowy
            </Button>
        </div>
    );
};

const holder = css`
    ${p(5)};
    ${mb(4)};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    border: 1px solid var(--colors-gray-800);
`;
